import { render, staticRenderFns } from "./ShopBox.vue?vue&type=template&id=2f1c921e&"
import script from "./ShopBox.vue?vue&type=script&lang=js&"
export * from "./ShopBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports